import { React, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
    Box, Switch, CircularProgress, Backdrop, TextField, Button, FormControl, Select,
    Dialog, DialogActions, DialogContent, DialogContentText, List, ListItem, Typography,
    InputLabel, ListItemText, Checkbox, OutlinedInput, MenuItem, Autocomplete, Chip
} from '@mui/material';
import {
    DataGridPro,
    GridToolbar
} from '@mui/x-data-grid-pro';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { toast } from 'react-toastify';
import axios from 'axios';

import { socket } from './socket';

var api = axios.create({ withCredentials: true });

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
        },
    },
};

function Users(props) {
    const { getAccessTokenSilently } = useAuth0();
    const [columns, setColumns] = useState(null);
    const [rows, setRows] = useState(null);
    const [dashboards, setDashboards] = useState([]);
    const [staff, setStaff] = useState([]);
    const [customers, setCustomers] = useState([]);
    const user = props.user;
    const isConnected = props.isConnected;
    const [openAdd, setAddOpen] = useState(false);
    const [addEmail, setAddEmail] = useState(null);
    const [addFname, setAddFname] = useState(null);
    const [addLname, setAddLname] = useState(null);
    const [adddashboards, setAddDashboards] = useState([]);
    const [adddashtext, setAddDashText] = useState([]);
    const [addstaff, setAddStaff] = useState([]);
    const [addstafftext, setAddStaffText] = useState([]);
    const [addcustomers, setAddCustomers] = useState([]);
    const [addcustomerstext, setAddCustomersText] = useState([]);
    const [addAdmin, setAddAdmin] = useState(false);
    const [openDelete, setDeleteOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteAuth, setDeleteAuth] = useState(null);

    const handleAddClickOpen = () => {
        setAddOpen(true);
    };
    const handleAddClose = () => {
        setAddEmail(null);
        setAddFname(null);
        setAddLname(null);
        setAddAdmin(false);
        setAddDashboards([]);
        setAddDashText([]);
        setAddStaff([]);
        setAddStaffText([]);
        setAddOpen(false);
    };

    function updateAddDashboards(value) {
        var adv = adddashboards;
        var adt = adddashtext;
        var f = false;
        adv.forEach((v) => {
            if (v === value) {
                f = true;
            }
        });
        if (f) {
            dashboards.forEach((db) => {
                if (db.value === value) {
                    adv = adv.filter((x) => {
                        return x !== value;
                    });
                    adt = adt.filter((x) => {
                        return x !== db.text;
                    });
                }
            });
        } else {
            adv.push(value);
            dashboards.forEach((db) => {
                if (db.value === value) {
                    adt.push(db.text);
                }
            });
        }

        setAddDashboards([...adv]);
        setAddDashText([...adt]);
    }

    function updateAddStaff(value) {
        var adv = addstaff;
        var adt = addstafftext;
        var f = false;
        adv.forEach((v) => {
            if (v === value) {
                f = true;
            }
        });
        if (f) {
            staff.forEach((db) => {
                if (db.value === value) {
                    adv = adv.filter((x) => {
                        return x !== value;
                    });
                    adt = adt.filter((x) => {
                        return x !== db.text;
                    });
                }
            });
        } else {
            adv.push(value);
            staff.forEach((db) => {
                if (db.value === value) {
                    adt.push(db.text);
                }
            });
        }

        if (value === 'All Staff') {
            adv = [];
            adt = [];
        }

        setAddStaff([...adv]);
        setAddStaffText([...adt]);
    }

    function updateAddCustomers(value) {
        var adv = addcustomers;
        var adt = addcustomerstext;
        var f = false;
        adv.forEach((v) => {
            if (v === value) {
                f = true;
            }
        });
        if (f) {
            customers.forEach((db) => {
                if (db.value === value) {
                    adv = adv.filter((x) => {
                        return x !== value;
                    });
                    adt = adt.filter((x) => {
                        return x !== db.text;
                    });
                }
            });
        } else {
            adv.push(value);
            customers.forEach((db) => {
                if (db.value === value) {
                    adt.push(db.text);
                }
            });
        }

        if (value === 'All Customers') {
            adv = [];
            adt = [];
        }

        setAddCustomers([...adv]);
        setAddCustomersText([...adt]);
    }

    function getDashboards() {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/dashboards/all`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
                var dashboards = [];
                response.data.forEach((dashboard) => {
                    dashboards.push({ key: dashboard._id, value: dashboard._id, text: dashboard.dashboard });
                });
                setDashboards(dashboards);
            }).catch((cerror) => {
                console.log(cerror.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function getStaff() {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/dashboards/staff`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
                var staff = [];
                response.data.forEach((s) => {
                    staff.push({ key: s._id, value: s._id, text: s.carrier_rep_name });
                });
                setStaff(staff);
            }).catch((cerror) => {
                console.log(cerror.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function getCustomers() {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/dashboards/customers`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
                var customers = [];
                response.data.forEach((s) => {
                    customers.push({ key: s._id, value: s._id, text: s.customer_name });
                });
                setCustomers(customers);
            }).catch((cerror) => {
                console.log(cerror.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function addNewUser() {
        if (
            addEmail !== null
            && addFname !== null
            && addLname !== null
            && addAdmin !== null
            && adddashboards.length > 0
        ) {
            getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0AUDIENCE,
                scope: process.env.REACT_APP_AUTH0SCOPE
            }).then((token) => {
                api.post(`${process.env.REACT_APP_BASEURL}/api/users/adduser`,
                    {
                        email: addEmail,
                        fname: addFname,
                        lname: addLname,
                        admin: addAdmin,
                        dashboards: adddashboards,
                        staff: addstaff,
                        customers: addcustomers
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                ).then((response) => {
                    setAddOpen(false);
                    toast.success(`User Added.`);
                }).catch((err) => {
                    if (err.message !== 'canceled') {
                        setAddOpen(false);
                        toast.error(err.response.data);
                    }
                });
            });
        } else {
            toast.error('All Fields are Required.');
        }
    }

    const handleDeleteClickOpen = () => {
        setDeleteOpen(true);
    };
    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    function deleteUser(id, auth0) {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/users/delete/${id}/${auth0}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            ).then((response) => {
                setDeleteId(null);
                setDeleteAuth(null);
                setDeleteOpen(false);
                toast.success(`User Deleted.`);
            }).catch((err) => {
                if (err.message !== 'canceled') {
                    setDeleteId(null);
                    setDeleteAuth(null);
                    setDeleteOpen(false);
                    toast.error(err.response.data);
                }
            });
        });
    }

    function toggleAdmin(id, admin, email) {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/users/admin/${admin}/${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            ).then((response) => {
                toast.success(`Admin status updated.`);
            }).catch((err) => {
                if (err.message !== 'canceled') {
                    toast.error(err.response.data);
                }
            });
        });
    }

    function toggleSpacex(id, value) {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/users/spacex/${value}/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            ).then(() => {
                toast.success(`SpaceX access updated.`);
            }).catch((err) => {
                if (err.message !== 'canceled') {
                    toast.error(err.response?.data || 'error');
                }
            });
        });
    }

    function updateDashboards(id, current, value) {
        var user_dashboards = [];
        var f = false;
        current.forEach((db) => {
            user_dashboards.push(db._id);
            if (db._id === value) {
                f = true;
            }
        });
        if (!f) {
            user_dashboards.push(value);
        } else {
            user_dashboards = user_dashboards.filter((x) => {
                return x !== value;
            });
        }
        if (user_dashboards.length === 0) {
            toast.error('You must assign at least one dashboard to a user.');
        } else {
            getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0AUDIENCE,
                scope: process.env.REACT_APP_AUTH0SCOPE
            }).then((token) => {
                api.post(
                    `${process.env.REACT_APP_BASEURL}/api/users/update/dashboards/${id}`,
                    { dashboards: user_dashboards },
                    { headers: { Authorization: `Bearer ${token}` } }
                ).then((response) => {
                    toast.success('Dashboards updated.');
                }).catch((error) => {
                    toast.error(error.response.data);
                });
            }).catch((token_error) => {
                console.log(token_error);
            });
        }
    }

    function updateStaff(id, current, value) {
        var user_staff = [];
        var f = false;
        current.forEach((db) => {
            user_staff.push(db._id);
            if (db._id === value) {
                f = true;
            }
        });
        if (!f) {
            user_staff.push(value);
        } else {
            user_staff = user_staff.filter((x) => {
                return x !== value;
            });
        }

        if (value === 'All Staff') {
            user_staff = [];
        }
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(
                `${process.env.REACT_APP_BASEURL}/api/users/update/staff/${id}`,
                { staff: user_staff },
                { headers: { Authorization: `Bearer ${token}` } }
            ).then((response) => {
                toast.success('Staff updated.');
            }).catch((error) => {
                toast.error(error.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function updateCustomers(id, current, value) {
        var user_customers = [];
        var f = false;
        current.forEach((db) => {
            user_customers.push(db._id);
            if (db._id === value) {
                f = true;
            }
        });
        if (!f) {
            user_customers.push(value);
        } else {
            user_customers = user_customers.filter((x) => {
                return x !== value;
            });
        }

        if (value === 'All Customers') {
            user_customers = [];
        }
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(
                `${process.env.REACT_APP_BASEURL}/api/users/update/customers/${id}`,
                { customers: user_customers },
                { headers: { Authorization: `Bearer ${token}` } }
            ).then((response) => {
                toast.success('Customers updated.');
            }).catch((error) => {
                toast.error(error.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function getUsers() {
        if (dashboards.length > 0) {
            getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0AUDIENCE,
                scope: process.env.REACT_APP_AUTH0SCOPE
            }).then((token) => {
                api.get(`${process.env.REACT_APP_BASEURL}/api/users/all`,
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                ).then((response) => {
                    var c = [
                        { field: 'col0', headerName: 'First Name', flex: .25, minWidth: 100, type: 'string' },
                        { field: 'col1', headerName: 'Last Name', flex: .25, minWidth: 100, type: 'string' },
                        { field: 'col2', headerName: 'Email', flex: .25, minWidth: 100, type: 'string' },
                        {
                            field: 'col3', headerName: 'Admin', flex: .25, minWidth: 100,
                            renderCell: (params) => {
                                return (
                                    <>
                                        {
                                            user._id === params.row.id
                                                ?
                                                <Switch
                                                    checked={params.value}
                                                    color='success'
                                                    disabled
                                                />
                                                :
                                                <Switch
                                                    checked={params.value}
                                                    color='success'
                                                    onClick={() => {
                                                        toggleAdmin(params.row.id, !params.value);
                                                    }}
                                                />
                                        }
                                    </>
                                );
                            }
                        },
                        {
                            field: 'spacex', headerName: 'SpaceX', flex: .25, minWidth: 100,
                            renderCell: (params) => (
                                <Switch
                                    checked={!!params.value}
                                    color='success'
                                    onClick={() => toggleSpacex(params.row.id, !params.value)}
                                />
                            ),
                        },
                        {
                            field: 'col4', headerName: 'Dashboards', flex: .75, minWidth: 120, display: 'flex',
                            valueGetter: (params) => {
                                var user_dashboards = [];
                                dashboards.forEach((db) => {
                                    params.forEach((ud) => {
                                        if (ud._id === db.key) {
                                            user_dashboards.push(db.text);
                                        }
                                    });
                                });
                                return user_dashboards.toString();
                            },
                            renderCell: (params) => {
                                var user_dashboards = [];
                                dashboards.forEach((db) => {
                                    params.row.col4.forEach((ud) => {
                                        if (ud._id === db.key) {
                                            user_dashboards.push(db.text);
                                        }
                                    });
                                });

                                return (
                                    <FormControl sx={{ minWidth: 120, maxWidth: '95%' }} size="small">
                                        <Select
                                            labelId="user-dash-select-label"
                                            id="user-dash-select"
                                            multiple
                                            autoWidth
                                            value={user_dashboards}
                                            onChange={(e, data) => { updateDashboards(params.row.id, params.row.col4, data.props.value) }}
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            {dashboards.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={user_dashboards.indexOf(db.text) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                );
                            }
                        },
                        {
                            field: 'staff', headerName: 'Staff', flex: .75, minWidth: 120, display: 'flex',
                            valueGetter: (params) => {
                                var user_staff = [];
                                staff.forEach((db) => {
                                    params.forEach((ud) => {
                                        if (ud._id === db.key) {
                                            user_staff.push(db.text);
                                        }
                                    });
                                });
                                return user_staff.length > 0 ? user_staff.toString() : "All Staff";
                            },
                            renderCell: (params) => {
                                var user_staff = [];
                                staff.forEach((db) => {
                                    params.row.staff.forEach((ud) => {
                                        if (ud._id === db.key) {
                                            user_staff.push(db.text);
                                        }
                                    });
                                });

                                const handleChange = (event, data) => {
                                    const value = data.props.value;
                                    updateStaff(params.row.id, params.row.staff, value);
                                };

                                return (
                                    <FormControl sx={{ minWidth: 120, maxWidth: '95%' }} size="small">
                                        <Select
                                            labelId="user-dash-select-label"
                                            id="user-dash-select"
                                            multiple
                                            autoWidth
                                            value={user_staff.length > 0 ? user_staff : ["All Staff"]}
                                            onChange={handleChange}
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key="all-staff" value="All Staff">
                                                <Checkbox checked={user_staff.length === 0} />
                                                <ListItemText primary="All Staff" />
                                            </MenuItem>
                                            {staff.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={user_staff.indexOf(db.text) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                );
                            }
                        },
                        {
                            field: 'customers', headerName: 'Customers', flex: .75, minWidth: 120, display: 'flex',
                            valueGetter: (params) => {
                                var user_customers = [];
                                customers.forEach((db) => {
                                    params.forEach((ud) => {
                                        if (ud._id === db.key) {
                                            user_customers.push(db.text);
                                        }
                                    });
                                });
                                return user_customers.length > 0 ? user_customers.toString() : "All Customers";
                            },
                            renderCell: (params) => {
                                var user_customers = [];
                                customers.forEach((db) => {
                                    params.row.customers.forEach((ud) => {
                                        if (ud._id === db.key) {
                                            user_customers.push(db.text);
                                        }
                                    });
                                });

                                const handleChange = (event, data) => {
                                    const value = data.props.value;
                                    updateCustomers(params.row.id, params.row.customers, value);
                                };

                                return (
                                    <FormControl sx={{ minWidth: 120, maxWidth: '95%' }} size="small">
                                        <Select
                                            labelId="user-dash-select-label"
                                            id="user-dash-select"
                                            multiple
                                            autoWidth
                                            value={user_customers.length > 0 ? user_customers : ["All Customers"]}
                                            onChange={handleChange}
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key="all-customers" value="All Customers">
                                                <Checkbox checked={user_customers.length === 0} />
                                                <ListItemText primary="All Customers" />
                                            </MenuItem>
                                            {customers.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={user_customers.indexOf(db.text) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                );
                            }
                        },
                        {
                            field: 'col5', headerName: 'Delete', flex: .25, minWidth: 130,
                            renderCell: (params) => {
                                return (
                                    <>
                                        {
                                            user._id === params.row.id
                                                ?
                                                <Button variant='contained' color='error' disabled size='small'>Delete User</Button>
                                                :
                                                <Button variant='contained' color='error' size='small' onClick={() => {
                                                    setDeleteId(params.row.id);
                                                    setDeleteAuth(params.value);
                                                    handleDeleteClickOpen();
                                                }}>Delete User</Button>
                                        }
                                    </>
                                );
                            }
                        },
                    ];
                    setColumns(c);

                    var r = [];
                    response.data.forEach((row) => {
                        r.push({
                            id: row._id,
                            col0: row.fname,
                            col1: row.lname,
                            col2: row.email,
                            col3: row.admin,
                            spacex: row.spacex,
                            col4: row.dashboards,
                            col5: row.auth0,
                            staff: row.staff,
                            customers: row.customers
                        });
                    });
                    setRows(r);
                }).catch((err) => {
                    if (err.message !== 'canceled') {
                        console.log(err);
                    }
                });
            });
        }
    }

    useEffect(() => {
        getDashboards();
        socket.on('dashboards', () => { getDashboards(); });
        getStaff();
        socket.on('staff', () => { getStaff(); });
        getCustomers();
        socket.on('customers', () => { getCustomers(); });

        return () => {
            socket.off('dashboards');
            socket.off('staff');
            socket.off('customers');
        };
    }, []);

    useEffect(() => {
        if (isConnected) {
            getUsers();
            socket.on('users', () => { getUsers(); });
        }

        return () => {
            socket.off('users');
        };
    }, [isConnected, dashboards.length, staff.length, customers.length]);

    if (user.admin) {
        if (columns !== null && rows !== null) {
            return (
                <>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: 10000000 }}
                        open={false}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog
                        open={openAdd}
                        onClose={handleAddClose}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogContent>
                            <List>
                                <ListItem>
                                    <TextField variant="standard" label='Email' onChange={(event) => { setAddEmail(event.target.value) }} sx={{ width: '100%' }} />
                                </ListItem>
                                <ListItem>
                                    <TextField variant="standard" label='First Name' onChange={(event) => { setAddFname(event.target.value) }} sx={{ width: '100%' }} />
                                </ListItem>
                                <ListItem>
                                    <TextField variant="standard" label='Last Name' onChange={(event) => { setAddLname(event.target.value) }} sx={{ width: '100%' }} />
                                </ListItem>
                                <ListItem />
                                <ListItem>
                                    <FormControl sx={{ width: '100%' }} size="small">
                                        <InputLabel id="user-dash-select-label">Dashboards</InputLabel>
                                        <Select
                                            labelId="user-dash-select-label"
                                            id="user-dash-select"
                                            multiple
                                            autoWidth
                                            value={adddashtext}
                                            onChange={(e, data) => { updateAddDashboards(data.props.value) }}
                                            input={<OutlinedInput label='Dashboards' />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            {dashboards.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={adddashboards.indexOf(db.value) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                                <ListItem>
                                    <FormControl sx={{ width: '100%' }} size="small">
                                        <InputLabel id="user-staff-select-label">Staff</InputLabel>
                                        <Select
                                            labelId="user-staff-select-label"
                                            id="user-staff-select"
                                            multiple
                                            autoWidth
                                            value={addstafftext.length > 0 ? addstafftext : ["All Staff"]}
                                            onChange={(e, data) => { updateAddStaff(data.props.value) }}
                                            input={<OutlinedInput label='Staff' />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key="all-staff" value="All Staff">
                                                <Checkbox checked={addstaff.length === 0} />
                                                <ListItemText primary="All Staff" />
                                            </MenuItem>
                                            {staff.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={addstaff.indexOf(db.value) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                                <ListItem>
                                    <FormControl sx={{ width: '100%' }} size="small">
                                        <InputLabel id="user-customers-select-label">Customers</InputLabel>
                                        <Select
                                            labelId="user-customers-select-label"
                                            id="user-customers-select"
                                            multiple
                                            autoWidth
                                            value={addcustomerstext.length > 0 ? addcustomerstext : ["All Customers"]}
                                            onChange={(e, data) => { updateAddCustomers(data.props.value) }}
                                            input={<OutlinedInput label='Customers' />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key="all-customers" value="All Customers">
                                                <Checkbox checked={addcustomers.length === 0} />
                                                <ListItemText primary="All Customers" />
                                            </MenuItem>
                                            {customers.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={addcustomers.indexOf(db.value) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                                <ListItem>
                                    <Typography variant='subtitle2'>Admin?</Typography>
                                    <Switch
                                        checked={addAdmin}
                                        color='success'
                                        onClick={() => {
                                            setAddAdmin(!addAdmin);
                                        }}
                                        sx={{ marginRight: '5px' }}
                                    />
                                </ListItem>
                            </List>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleAddClose}>Cancel</Button>
                            <Button onClick={() => { addNewUser(); }}>Add User</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={openDelete}
                        onClose={handleDeleteClose}
                    >
                        <DialogContent>
                            <DialogContentText>Are you sure you want to delete this user account?</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDeleteClose} autoFocus>Cancel</Button>
                            <Button color="error" onClick={() => { deleteUser(deleteId, deleteAuth); }}>Delete User Account</Button>
                        </DialogActions>
                    </Dialog>
                    <Box flexGrow={1} sx={{ padding: '20px' }}>
                        <Button onClick={handleAddClickOpen}>Add New User</Button>
                        <div style={{ height: '80vh', width: '100%' }}>
                            <DataGridPro
                                slots={{
                                    toolbar: GridToolbar
                                }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 }
                                    }
                                }}
                                rows={rows}
                                columns={columns}
                                pagination
                                disableRowSelectionOnClick
                            />
                        </div>
                    </Box>
                </>
            );
        } else {
            return (
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 3, alignItems: 'center', textAlign: 'center' }}
                >
                    <CircularProgress size={60} thickness={4} />
                </Box>
            );
        }
    } else {
        return (
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 3, alignItems: 'center', textAlign: 'center' }}
            >
                <WarningRoundedIcon size={60} thickness={4} />
                <p>Not Authorized</p>
            </Box>
        );
    }
}

export default Users;